import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IAsset } from '@api'

interface IProps {
  id: string
  content: string
}

function create({ id, content }: IProps): Promise<IAsset> {
  return client.gql
    .mutate({
      mutation: createMutation,
      variables: { input: { employee_id: id, content } },
    })
    .then(
      ({
        data: {
          createEmployeeAsset: { asset },
        },
      }: any) => asset
    )
}

function update({ id, content }: IProps): Promise<IAsset> {
  return client.gql
    .mutate({
      mutation: updateMutation,
      variables: { input: { id, content } },
    })
    .then(
      ({
        data: {
          updateEmployeeAsset: { asset },
        },
      }: any) => asset
    )
}

const createMutation = gql`
  mutation _($input: CreateEmployeeAssetInput!) {
    createEmployeeAsset(input: $input) {
      asset {
        id
        url
      }
    }
  }
`
const updateMutation = gql`
  mutation _($input: UpdateEmployeeAssetInput!) {
    updateEmployeeAsset(input: $input) {
      asset {
        id
        url
      }
    }
  }
`

export default {
  create,
  update,
}
